

























































































import Vue from 'vue';
import vue2Dropzone from 'vue2-dropzone';
import { mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import EssayReply from '@/dex-shared/models/EssayReplyModel';
import { fileUploadURL } from '@/dex-shared/settings/endpoints';
import { TRACK_TYPES } from '@/dex-shared/helpers/track';

export default Vue.extend({
  components: {
    pxButton,
    vueDropzone: vue2Dropzone,
  },
  props: {
    essay: {
      type: EssayReply,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      sentImage: false,
      dropzoneOptions: {
        url: fileUploadURL,
        thumbnailWidth: 660,
        thumbnailMethod: 'contain',
        maxFiles: 1,
        autoQueue: false,
        acceptedFiles: 'image/*',
      },
    };
  },
  computed: {
    ...mapGetters({
      userEssayCredits: 'userEssayCredits',
    }),
    buttonState(): string {
      const classes = [];
      if (!this.sentImage || this.userEssayCredits == 0) {
        classes.push('button-disabled');
      } else if (this.loading) {
        classes.push('loading-button');
      }
      return '';
    },
  },
  methods: {
    onFileAdded() {
      this.$track(TRACK_TYPES.ESSAY_STARTED, {
        discipline: 'redacao',
        essaySubject: this.essay.subject().slug,
        sentMethod: 'image',
      });
      this.$track(TRACK_TYPES.INTEGRATION_EVENT, {
        integration: 'imaginie',
        type: 'Essay Started',
      });
      this.sentImage = true;
    },
    async sendEssay() {
      this.loading = true;
      let acceptedFiles = this.$refs.dropzone.getAcceptedFiles();
      if (acceptedFiles.length > 0) {
        const imageData = acceptedFiles[0].dataURL;
        const essayReplyUrl = await this.$store.dispatch(
          'UPLOAD_IMAGE',
          imageData,
        );
        const essaySubjectId = this.essay.subject().id;
        const imageURL = await this.$store.dispatch('UPLOAD_IMAGE', imageData);
        await this.$store.dispatch('CREATE_AND_ASSOCIATE_IMAGE', {
          url: essayReplyUrl,
          essayId: this.essay.id,
        });
        await this.$store.dispatch('PUSH_ESSAY', this.essay.id);
        this.$track(TRACK_TYPES.ESSAY_CONSUMED, {
          discipline: 'redacao',
          essaySubject: this.essay.subject().slug,
          essayId: this.essay.id,
          sentMethod: 'image',
        });
        this.$track(TRACK_TYPES.INTEGRATION_EVENT, {
          integration: 'imaginie',
          type: 'Essay Sent',
        });
      } else {
        /* alert user that no image was uploaded */
        this.$track(TRACK_TYPES.INTEGRATION_VIEWED, {
          integration: 'imaginie',
          type: 'Error',
          error_message: 'Image wasnt received',
        });
        console.error('Image wasnt received');
      }
      this.loading = false;
    },
    swapEssay() {
      this.$refs.dropzone.removeAllFiles();
    },
  },
});
